import { copyToClipboard } from "@/helpers/ClipboardHelpers";
import { ClipboardIcon } from "@heroicons/react/20/solid";
import { format } from "date-fns";
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

export const AssignmentRow = ({ assignment, currentEmployeeName, key, isAdmin }) => {
	try {
		assignment.start = format(new Date(assignment.start), "do MMMM yyyy");
		assignment.end =
			assignment.end == "null" ? "Not Yet Returned" : format(new Date(assignment.end), "do MMMM yyyy");
	} catch (error) {
		console.warn(error);
	}

	return (
		<tr key={key}>
			<td>
				{isAdmin && (
					<div
						className="btn btn-xs btn-default"
						type="button"
						onClick={() => copyToClipboard(assignment.id)}
						style={{ marginRight: 10 }}
					>
						<ClipboardIcon
							className="h-5 w-5 text-dark-gray"
							style={{ marginTop: "3px" }}
						/>
					</div>
				)}
			</td>
			<td>
				<Link to={`/organisation/people/${assignment.agreement}`}>{currentEmployeeName}</Link>
			</td>
			<td>{assignment.start}</td>
			<td>{assignment.end}</td>
			{/* <td>{assignment.dateReturned}</td> */}
		</tr>
	);
};

const mapStateToProps = (state, ownProps) => {
    const currentEmployee = state.employees?.employeeListWithSalary?.find(item => item.id === ownProps.assignment.agreement)
    const currentEmployeeName = currentEmployee ? `${currentEmployee?.employeeName} ${currentEmployee?.employeeSurname}` : undefined
    return {
        currentEmployeeName,
        isAdmin: state?.my?.profile?.isAdmin
    };
};

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(AssignmentRow);
